export const AccountingIntegrations = {
    none: 0,
    apideck: 1,
    quickbooks_desktop: 2,
}

export const APIDeckTaxStrategies = {
    normal: 0,
    manual: 1,
    automatic: 2,
}

export const PriceBookItemTypes = {
    service: 1,
    part: 2,
    other: 3,
    discount: 4,
    tax: 5,
}

export const RecurrenceFrequency = {
    DAILY: 3,
    WEEKLY: 2,
    MONTHLY: 1,
    YEARLY: 0,
}

export const FREQUENCY_OPTIONS = [
    { value: RecurrenceFrequency.DAILY, label: "Day" },
    { value: RecurrenceFrequency.WEEKLY, label: "Week" },
    { value: RecurrenceFrequency.MONTHLY, label: "Month" },
    { value: RecurrenceFrequency.YEARLY, label: "Year" },
]

export const WEEKDAY_OPTIONS = [
    { value: 0, label: "Mon", short: "M" },
    { value: 1, label: "Tue", short: "T" },
    { value: 2, label: "Wed", short: "W" },
    { value: 3, label: "Thu", short: "T" },
    { value: 4, label: "Fri", short: "F" },
    { value: 5, label: "Sat", short: "S" },
    { value: 6, label: "Sun", short: "S" },
]

export const JobSeriesType = {
    UPFRONT: "upfront",
    ROLLING: "rolling",
}

export const InventoryLevels = {
    depleted: 0,
    low: 1,
    limited: 2,
    full: 3,
} as const

export const BillingIntentions = {
    SERVICE_CLIENT: 0,
    SERVICE_LOCATION: 1,
    DIFFERENT_CLIENT: 2,
} as const

export const BillingIntentionLabels = {
    [BillingIntentions.SERVICE_CLIENT]: "Service Client",
    [BillingIntentions.SERVICE_LOCATION]: "Service Location",
    [BillingIntentions.DIFFERENT_CLIENT]: "Different Client",
} as const

export const CreditNoteStatuses = {
    pending: 0,
    issued: 1,
    voided: 2,
} as const
